import React, { Component } from 'react';
import StepFooter from '../StepFooter';
import PropTypes from 'prop-types';
import _ from 'lodash';

class Step3 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      desiredSigningLevel: '',
      errorMessage: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.footerNext = this.footerNext.bind(this);
  }

  getSuggestedLevelMessage () {
    if (this.props.professionId > 0) {
      const profession = _.find(this.props.professions, (p) => {
        return p.id === this.props.professionId;
      });
      const levels = profession.levels;
      let message = 'For "' + profession.title + '" we suggest Level ' + levels[0];
      if (levels.length > 1) {
        message += ' or above'
      }
      return message;
    }
    return '';
  }

  getErrorMessage (state) {
    let validationError = '';
    if (state.desiredSigningLevel === '') {
      validationError = 'Please select a desired signing level before clicking next';
    }
    return validationError;
  }

  handleChange (event) {
    let state = this.state;
    state.desiredSigningLevel = Number(event.target.value);
    // update the error mesage if there already was one
    //
    if (state.errorMessage) {
      state.errorMessage = this.getErrorMessage(this.state);
    }
    this.setState(state);
  }

  footerNext (event) {
    let validationError = this.getErrorMessage(this.state);
    if (validationError) {
      event.preventDefault();
      this.setState({
        errorMessage: validationError
      });
    } else {
      this.props.handleNextClick({
        desiredSigningLevel: Number(this.state.desiredSigningLevel)
      });
    }
  }

  render () {
    let levels = this.props.getLevels();
    return (
      <div className='registration__step'>
        <div className='registration__inner'>
          <p className='registration__step-indicator'>Step 3 of 4</p>
          <p className='kilo'>I want to be signing at...</p>

          <ul className='form-fields'>
            <li>
              <div className='select'>
                <select className={this.state.errorMessage && 'has-error'} name='' id=''
                  value={this.state.desiredSigningLevel} onChange={this.handleChange}>
                  <option value='' disabled>Please choose one...</option>
                  {levels.map((level) => {
                    return <option key={level} value={level} >Level {level}</option>;
                  })}
                </select>
              </div>
              <p className='label-extra' style={{height:10}}>{this.getSuggestedLevelMessage()}</p>
            </li>
          </ul>
          <StepFooter
            handlePreviousClick={this.props.handlePreviousClick}
            errorMessage={this.state.errorMessage}
            handleNextClick={this.footerNext} />
        </div>
      </div>
    );
  }
}

Step3.propTypes = {
  handlePreviousClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  getLevels: PropTypes.func.isRequired,
  professions: PropTypes.array.isRequired,
  professionId: PropTypes.number.isRequired
};

export default Step3;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/Step3/index.js